import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import { useCurrentScoreId, useCurrentAlbumId, useQueryParam } from "./state";
import { useEffect } from "react";
import { findByKey, pushSafelyToArray } from "./util/immut";
import { useNavigate } from "react-router";
import { Tune } from "./tune";
import { albumTuneListAtom } from "./album_tunes";
import { DAO } from "./dao/dao";
import { run } from "./util/lazy";

const scoresOpenAtom = atom<Tune[]>([]);

const msgAtom = atom("");

async function getTuneDirectly(albumId: string) {
  const name = await DAO.getEntityName(albumId);
  return new Tune(name, albumId);
}

export function useOpenScores() {
  const [scoresOpen, setScoresOpen] = useAtom(scoresOpenAtom);
  const s = useCurrentScoreId();
  const a = useCurrentAlbumId();
  const tuneList = useAtomValue(albumTuneListAtom);

  useEffect(() => {
    setScoresOpen([]);
  }, [a]);

  useEffect(() => {
    run(async () => {
      const newScore =
        s && tuneList.isEmpty
          ? await getTuneDirectly(s)
          : findByKey(tuneList.getTunesSorted(), "id", s);
      if (!newScore) return;
      if (findByKey(scoresOpen, "id", s)) return;
      setScoresOpen(pushSafelyToArray(newScore, "id"));
    });
  }, [s, tuneList]);
  return scoresOpen;
}

export function useCloseScore() {
  const [scoresOpen, setScoresOpen] = useAtom(scoresOpenAtom);
  const [q] = useQueryParam();
  const navigate = useNavigate();
  return (id: string) => {
    const tuneIdx = scoresOpen.findIndex((t) => t.id === id);
    const arr = [...scoresOpen];
    arr.splice(tuneIdx, 1);
    const nextTune = arr.length === 0 ? null : arr[(tuneIdx - 1) % arr.length];
    const backUrl = q.has("album") ? `/view?album=${q.get("album")}` : "/";
    const url = !nextTune
      ? backUrl
      : `/view?score=${nextTune.id}` +
        (q.has("album") ? `&album=${q.get("album")}` : "");
    navigate(url);
    setScoresOpen(arr);
  };
}

export function useNextScore() {
  const scoresOpen = useAtomValue(scoresOpenAtom);
  const setMsg = useSetAtom(msgAtom);
  const [q] = useQueryParam();
  const navigate = useNavigate();
  return (id: string, ward: "forward" | "backward") => {
    const numScores = scoresOpen.length;
    if (numScores === 1) {
      return;
    }
    const tuneIdx = scoresOpen.findIndex((t) => t.id === id);
    let targetIdx = tuneIdx + (ward === "forward" ? 1 : -1);
    if (targetIdx < 0) {
      targetIdx = numScores - 1;
    }
    if (targetIdx > numScores - 1) {
      targetIdx = 0;
    }
    const targetId = scoresOpen[targetIdx].id;
    const urlSuffix = q.has("album") ? `&album=${q.get("album")}` : "";
    const url = `/view?score=${targetId}` + urlSuffix;
    navigate(url);
    setMsg(scoresOpen[targetIdx].name);
    setTimeout(() => {
      setMsg("");
    }, 500);
  };
}

export function usePopupMessage() {
  return useAtomValue(msgAtom);
}
